export default __webpack_public_path__ + "info-circle-fill.43acd7cf.svg";